






















































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import {HardwareDataType} from '@/system/hardware/enums';
import {PModuleMAC} from '@/views/system/modules/interfaces';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import {connectionGetActiveDevices} from '@/api/configApi';
import dtcpServerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class HardwareDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonMACAddressRule = (v: any) => this.RegExPattern.test(v) || 'Поле должно быть МАС адресом';
  StringIsNumber = (value: any) => isNaN(Number(value)) === false;

  // список mac адресов для выбора
  macs: PModuleMAC[] = [];

  socket!: WebSocket | null;

  @Prop()
  hardwareTypes!: any[];

  @Prop() isEdit!: boolean;

  // список mac адресов для выбора
  filteredMacs: PModuleMAC[] = [];

  get types() {
    return Object.keys(HardwareDataType)
      .filter(this.StringIsNumber)
      .map((name: any) => {
        return {
          type: parseInt(name),
          name: HardwareDataType[name],
        };
      });
  }

  hardwareTypesList!: any;

  saveData() {
    (this.$refs.combobox as any).blur();
    this.$nextTick(() => {
      this.save();
    });
  }

  @Watch('data')
  async onLoadData() {
    // получаем все модули и находим dtcp-сервер
    await pmoduleModule.fetchAll();
    const dtcpServers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpServerModule);
    if (dtcpServers.length) {
      // если есть dtcp-сервера, берем один из них
      const dtcpServer = dtcpServers[0];

      if (dtcpServer.guid) {
        //подключаемся к веб сокету
        this.socket = connectionGetActiveDevices(dtcpServer.guid);
        this.socket.onopen = () => {
          //отправляем action
          if (dtcpServer.id) {
            dtcpServerStoreModule.processGetActiveDevicesAction({id: dtcpServer.id});
          }
        };
        this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
      }
    }
  }

  onTypeIdChanged() {
    if (this.data?.type_id) {
      const type = this.hardwareTypes.filter(x => x.id == this.data.type_id);
      const typeOfType = type.map(y => y.type);
      // если у типа АМ указан тип, то фильтруем мак адреса по этому типу
      // Иначе - отображаем все мак адреса.
      if (typeOfType) {
        this.filteredMacs = this.macs.filter((mac: any) => mac.description.includes(typeOfType));
      } else this.filteredMacs = this.macs;
    }
  }

  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    const macs = strParse.data.devices.map((x: any) => ({
      device: x.mac,
      description: `${x.mac} - ${x.type} (${x.fw_ver})`,
    }));
    if (
      this.data &&
      this.data.mac &&
      this.macs.filter(v => v.device === this.data.mac).length <= 0
    ) {
      this.macs = [...macs, {device: this.data.mac, description: this.data.mac}];
    } else {
      this.macs = [...macs];
    }
    this.onTypeIdChanged();
  }

  beforeDestroy() {
    this.closeWS();
  }

  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}
